import bop, { transform } from '../../../../bop';
import mapBodyToEntity from '../../utils/mapBodyToEntity';
import * as Error from '../../utils/error';
import * as GroupsErrors from '../../errors/groups';

/**
 * Create collaboration group
 * @param {string} type
 * @param {array<string>} filerrIds
 * @param {string} contextType
 * @param {(string|number)} contextId
 * @returns {Promise}
 * @resolves {object} group
 * @resolves {string} group.id - The group id.
 * @resolves {array<string>} group.fileIds - The collaboration file ids in this group.
 * @resolves {string} group.type - The group type.
 * @rejects {Error}
 */
export const create = (payload) =>
    Promise.resolve().then(() => {
        if (!payload) {
            throw Error.create(
                `Payload is falsy: ${payload}`,
                GroupsErrors.GROUPS_APIS_CREATE_FALSY_PAYLOAD,
                payload
            );
        }
    }).then(() =>
        bop.post('/collaboration/groups', payload)
            .before({ transformPayload: transform.toSnakeCase })
            .after({ statusCode: 201, transformBody })
            .run()
    ).catch((error) => {
        if (!error.code) {
            error.code = GroupsErrors.GROUPS_APIS_CREATE_UNEXPECTED;
            error.details = { payload: JSON.stringify(payload) };
        }

        throw error;
    });

function transformBody(body) {
    const camelCaseBody = transform.toCamelCase(body);
    return Object.values(mapBodyToEntity(camelCaseBody, 'groups'))[0];
}
